import {
  AdPolicy,
  MemoryAdFrequencyStore,
  NullAdProvider,
  TestAdProvider,
  type AdRequestContext,
} from "@mcebey/ads-kit";
import {
  AggregateAnalytics,
  MemoryAnalyticsStore,
  type AnalyticsEventDefinition,
} from "@mcebey/analytics-kit";

const componentOpened: AnalyticsEventDefinition = {
  name: "component_opened",
  dimensions: {
    category: {type: "category", values: ["common", "push", "agenda", "opo", "visagismo"]},
  },
};
const store = new MemoryAnalyticsStore();
const analytics = new AggregateAnalytics({
  app: "design-system-showcase",
  appVersion: "0.2.0",
  build: "dev",
  environment: "dev",
  platform: "web",
  language: "es",
}, "localOnly", store);

export const showcasePlatformCapabilities = {
  opened(category: string): number {
    analytics.record(componentOpened, {category});
    return this.count();
  },
  count(): number {
    return store.snapshot().reduce((total, item) => total + item.count, 0);
  },
  clear(): void {
    store.clear();
  },
};

export async function verifyShowcaseAdProviders(): Promise<void> {
  const placement = {
    id: "showcase_component_slot",
    allowedFormats: ["native"] as const,
    sensitivity: "normal" as const,
    minimumIntervalSeconds: 0,
    environments: ["dev"] as const,
  };
  const context: AdRequestContext = {
    app: "design-system-showcase",
    placement,
    language: "es",
    broadContentCategory: "components",
    environment: "dev",
    format: "native",
  };
  const allowed = new AdPolicy("test", "contextual", false, false, new MemoryAdFrequencyStore()).evaluate(context);
  const blocked = new AdPolicy("disabled", "disabled", false, true, new MemoryAdFrequencyStore()).evaluate(context);
  const ready = await new TestAdProvider().load(context, allowed);
  const emptyOrBlocked = await new NullAdProvider().load(context, blocked);
  if (ready.kind !== "ready" || emptyOrBlocked.kind !== "blocked") throw new Error("invalid_showcase_ad_states");
}
